import { useCallback, useEffect } from "react";
import { getPlatform } from "../../Core/Util/Helpers";

const sendProductViewEventToApi = (payload) => {
   const baseUrl = `https://plenum.digifiservices.se/prod/vb-proxy/api/events/product-view`;

   return fetch(baseUrl, {
      method: 'POST', 
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
   })
   .then(response => {
      if (!response.ok) {
         console.error(`Failed to send product view event: ${response.statusText}`);
      }
   })
   .catch(error => {
      console.error('Error sending product view event:', error);
   });
};

export const useProductViewEvent = sku => {
   const sendProductViewEvent = useCallback(() => {
      const payload = {
         deviceInfo: {
            userAgent: navigator.userAgent,
            platform: getPlatform(),
            language: navigator.language,
            deviceMemory: navigator.deviceMemory,
            screenResolution: `${window.screen.width}x${window.screen.height}`,
            windowSize: `${window.innerWidth}x${window.innerHeight}`,
            // hardwareConcurrency: navigator?.hardwareConcurrency,
            // touchPoints: navigator.maxTouchPoints,
            // devicePixelRatio: window.devicePixelRatio,
            // vendor: navigator.vendor,
         },
         userIdentifier: null,
         ipAddress: null,
         sku: sku
      };

      sendProductViewEventToApi(payload);
   }, [sku]);

   useEffect(() => {
      if (sku) {
         sendProductViewEvent();
      }
   }, [sku, sendProductViewEvent]);
};